import { useEffect, useState } from "react";
import { IoIosCloseCircle } from "react-icons/io";
import { Oval } from "react-loader-spinner";
import { getAddressInformations } from "../../../../scripts/getAddressInformations";
import styles from "./css/confirmAddress.module.css";




function ConfirmAddressData ({close, show, postalCode}) {

    const [postalData, setPostalData] = useState(null);
    const [loading, setLoading] = useState(true);


    useEffect(() => {
        (async () => {
            try{
                setLoading(true);
                
                if(show){
                    const resPostalData = await getAddressInformations(postalCode);
    
                    setPostalData(resPostalData);
                }

            } finally {
                setLoading(false);
            }
        })();

    }, [show])


    return show && (
        <div className={styles.confirmAddressArea}>
            <div className={styles.confirmAddressOverflow} />

            <div className={styles.confirmAddressBox} >

                {/* BOX HEADER */}
                <div className={styles.confirmAddressBoxHeader}>
                    <div className={styles.boxHeaderContainer}>
                        <h1 className={styles.titleBox}>Conferir endereço</h1>

                        <button className={styles.closeBtn} onClick={() => close()}>
                            <IoIosCloseCircle size={30} color='#fff'/>
                        </button>

                    </div>
                </div>

                {/* BOX CONTAINER AREA */}

                <div id={styles.boxContainer} style={{display: 'flex', flexDirection: 'column', textAlign: 'start'}}>
                    {loading ? (
                        <Oval 
                            visible={true}
                            height="40"
                            width="40"
                            color="#2eb4f1"
                            ariaLabel="oval-loading"
                        />

                    ) : (
                        <div style={{width: '80%', alignSelf: 'center'}}>
                            <p className={styles.titleInformations}>Endereço de cobrança:</p>

                            <div style={{padding: 10, backgroundColor: '#d3d3d3', borderRadius: 10}}>
                                <p className={styles.textInformations}>
                                    <b>CEP:</b> {postalData?.cep}
                                </p>

                                <p className={styles.textInformations}>
                                    <b>Cidade:</b> {postalData?.city}
                                </p>

                                <p className={styles.textInformations}>
                                    <b>UF:</b> {postalData?.state}
                                </p>

                                <p className={styles.textInformations}>
                                    <b>Rua:</b> {postalData?.street}
                                </p>

                                <p className={styles.textInformations}>
                                    <b>Bairro:</b> {postalData?.district}
                                </p>
                            </div>
                        </div>
                    )}
                </div>

            </div>
        </div>
    )
}


export default ConfirmAddressData;